// extracted by mini-css-extract-plugin
module.exports = {"Tab":"AssesmentTab_Tab__dovOq","PaymentIcon":"AssesmentTab_PaymentIcon__3-aDp","TextBold":"AssesmentTab_TextBold__nbZ4H","Text":"AssesmentTab_Text__1jsNI"};